module.exports = __webpack_public_path__ + "static/stent-long-98c2716120b9972c2036626793a6d871.jpg";